import { useCallback, useMemo } from 'react';
import { toast } from 'sonner';
import api, { formatApiError } from '../../lib/api';

export function useVoucherActions({ refresh }) {
  const createVoucher = useCallback(async ({ code, type, value, minSpend, scope }) => {
    try {
      const res = await api.post('/vouchers', { code, type, value: Number(value), minSpend: Number(minSpend) || 0 });
      toast.success(`Voucher ${res.data.code} created`, {
        description: res.data.scope === 'MERCHANT' ? 'Valid on your store. Funded by you (deducted from settlement).' : 'Valid on every store. Funded by KELATE.',
      });
      await refresh(true);
      return res.data;
    } catch (e) { toast.error(formatApiError(e)); return null; }
  }, [refresh]);

  const toggleVoucher = useCallback(async (code) => {
    try {
      await api.post(`/vouchers/${code}/toggle`);
      await refresh(true);
    } catch (e) { toast.error(formatApiError(e)); }
  }, [refresh]);

  return useMemo(() => ({ createVoucher, toggleVoucher }), [createVoucher, toggleVoucher]);
}
